var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("uploadImage", {
        attrs: { value: _vm.picfileList },
        on: { input: _vm.imgChange }
      }),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "20px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.configLogo } },
                [_vm._v("修改")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }